/**
 * Conversão do custo de IA (a API cobra em dólar) para exibição em reais.
 * Cotação fixa: o número é informativo, não contábil — cotação ao vivo
 * traria dependência externa para uma diferença de centavos.
 */
export const COTACAO_USD_BRL = 5.1177; // PTAX de venda do Banco Central em 28/07/2026

export function custoEmReaisFormatado(valorUsd: number): string {
  const custoEmReais = (Number(valorUsd) || 0) * COTACAO_USD_BRL;
  const casasDecimais = custoEmReais >= 1 ? 2 : 4;
  return custoEmReais.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: casasDecimais,
    maximumFractionDigits: casasDecimais
  });
}
